import { useEffect, useState } from 'react';

import { NumberParam, useQueryParam } from 'use-query-params';

const useActivePage = (location) => {
  const [currentPage, setCurrentPage] = useQueryParam('page', NumberParam);
  const [activePage, setActivePage] = useState(1);

  useEffect(() => {
    const page = new URLSearchParams(location.search).get('page');
    setActivePage(Number(page || '1'));
  }, [currentPage]);

  return { setActivePage, activePage, currentPage, setCurrentPage };
};

export default useActivePage;
